import { registerLightIcon } from "./registerLightIcon";
import { lightRibbonIconFont } from "./lightRibbonIconFont";

export const registerAllLightIcons = (isMultiLineRibbon: boolean): void => {
    if (isMultiLineRibbon) {
        lightRibbonIconFont.forEach(iconName => {
            registerLightIcon(iconName);
        });
    }
};
